import React from 'react';
import { useHistory } from 'react-router-dom';
import { notification } from 'antd';
import '../styles/notification.css';
import { links } from '../../../constants/links';
import { useSelector } from 'react-redux';

const MessageBlock = ({ onClickBtn, keyNotification }) => {
  return (
    <div className="notification-message-block">
      <div className="notification-message-text">
        Загрузка отчета РСО завершена
      </div>
      <div
        className="my-notification-custom_btn"
        onClick={() => onClickBtn(keyNotification)}
      >
        Открыть
      </div>
    </div>
  );
};

const useShowNotification = () => {
  const history = useHistory();

  const currentCompany = useSelector(
    (state) => state.housingStockStore.currentCompany
  );

  const onClickBtn = (key) => {
    history.push(
      `${links.rootWithCompany}/${currentCompany?.id}/${links.reportRSO}`
    );
    notification.close(key);
  };

  const showNotification = () => {
    const key = `open${Date.now()}`;
    notification.open({
      message: (
        <MessageBlock
          onClickBtn={onClickBtn}
          keyNotification={key}
        />
      ),
      key,
      duration: 0,
      className: 'my-notification-custom',
    });
  };

  return showNotification;
};

export default useShowNotification;
